"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeTriggerDataByType = exports.encodeTriggerData = exports.decodeTriggerDataByTypeAsJson = exports.decodeTriggerDataByType = exports.decodeTriggerDataAsJson = exports.decodeTriggerData = void 0;
const ethers_1 = require("ethers");
const mapping_1 = require("./mapping");
function decodeTriggerData(commandAddress, network, data) {
    const paramTypes = (0, mapping_1.getDefinitionForCommandAddress)(commandAddress, network);
    return ethers_1.utils.defaultAbiCoder.decode(paramTypes, data);
}
exports.decodeTriggerData = decodeTriggerData;
function decodeTriggerDataAsJson(commandAddress, network, data) {
    const arr = decodeTriggerData(commandAddress, network, data);
    const type = mapping_1.commandAddressMapping[network][commandAddress].type;
    return arr.reduce((acc, curr, idx) => {
        acc[mapping_1.commandTypeJsonMapping[type][idx]] = curr.toString();
        return acc;
    }, {});
}
exports.decodeTriggerDataAsJson = decodeTriggerDataAsJson;
function decodeTriggerDataByType(type, data) {
    const paramTypes = (0, mapping_1.getDefinitionForCommandType)(type);
    return ethers_1.utils.defaultAbiCoder.decode(paramTypes, data);
}
exports.decodeTriggerDataByType = decodeTriggerDataByType;
function decodeTriggerDataByTypeAsJson(type, data) {
    const arr = decodeTriggerDataByType(type, data);
    return arr.reduce((acc, curr, idx) => {
        acc[mapping_1.commandTypeJsonMapping[type][idx]] = curr.toString();
        return acc;
    }, {});
}
exports.decodeTriggerDataByTypeAsJson = decodeTriggerDataByTypeAsJson;
function encodeTriggerData(commandAddress, network, values) {
    const paramTypes = (0, mapping_1.getDefinitionForCommandAddress)(commandAddress, network);
    return ethers_1.utils.defaultAbiCoder.encode(paramTypes, values);
}
exports.encodeTriggerData = encodeTriggerData;
function encodeTriggerDataByType(type, values) {
    const paramTypes = (0, mapping_1.getDefinitionForCommandType)(type);
    return ethers_1.utils.defaultAbiCoder.encode(paramTypes, values);
}
exports.encodeTriggerDataByType = encodeTriggerDataByType;
//# sourceMappingURL=abi-coding.js.map